import { RawTrade } from './types';

const getExpiryString = (trade: RawTrade) =>
  `${trade.expireYear}-${trade.expireMonth}-${trade.expireDay}`;

export default getExpiryString;
